import React, { useEffect } from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const pillars = [
    {
        title: "Game Production",
        points: [
            "Product Vision",
            "Production Planning",
            "Agile & Scrum",
            "Sprint Planning",
            "Roadmap Management",
            "Milestone Tracking",
            "Stakeholder Communication",
            "Team Leadership",
        ],
    },
    {
        title: "Technical Leadership",
        points: [
            "Unity Development",
            "Multiplayer Systems",
            "Architecture Planning",
            "Technical Decision Making",
            "Code Reviews",
            "Performance Optimization",
            "Mentorship",
        ],
    },
    {
        title: "Product Ownership",
        points: [
            "Feature Prioritization",
            "Client Workshops",
            "Gameplay Design",
            "User Experience",
            "Release Planning",
            "Live Operations",
        ],
    },
];

const Services = () => {
    useEffect(() => {
        const options = { threshold: 0.25 };

        const listObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const listEl = entry.target;
                const article = listEl.closest(".service");
                if (!article) return;

                if (entry.isIntersecting) {
                    article.classList.add("revealed");
                } else {
                    article.classList.remove("revealed");
                    // force reflow to allow replay
                    // eslint-disable-next-line no-unused-expressions
                    void listEl.offsetWidth;
                }
            });
        }, options);

        const lists = document.querySelectorAll(".service__list");
        lists.forEach((list) => listObserver.observe(list));

        return () => {
            lists.forEach((list) => listObserver.unobserve(list));
        };
    }, []);

    return (
        <section id="services">
            <h5>How I Add Value</h5>
            <h2>What I Do</h2>
            <div className="container services__container">
                {pillars.map(({ title, points }) => (
                    <article className="service" key={title}>
                        <div className="service__head">
                            <h3>{title}</h3>
                        </div>
                        <ul className="service__list">
                            {points.map((point, i) => (
                                <li key={point} style={{ ["--i"]: i }}>
                                    <span className="point-icon"><BiCheck /></span>
                                    <p>{point}</p>
                                </li>
                            ))}
                        </ul>
                    </article>
                ))}
            </div>
        </section>
    );
};

export default Services;
